jQuery.fn.extend({
	notification: function (options = {}) {
		return this.each(function () {
			var
				$notification = $(this),
				$closeButton = $($notification.data('close-button') || options.button);

			function open() {
				$notification
					.trigger('notification:show')
					.attr('aria-hidden', false)
					.slideDown(function () {
						$closeButton
							.attr('aria-expanded', true);
						$notification
							.trigger('notification:shown');
					});
			}

			function close() {
				$notification
					.trigger('notification:hide')
					.attr('aria-hidden', true)
					.slideUp(function () {
						$closeButton
							.attr('aria-expanded', false);
						$notification
							.trigger('notification:hidden');
					});
			}

			$notification
				.attr('aria-labelledby', $closeButton.attr('id'))
				.on('notification:open', open)
				.on('notification:close', close);

			$closeButton
				.attr('aria-controls', $notification.attr('id'));

			$('.close', $notification)
				.on('click', close);
		});
	}
});



// WEBPACK FOOTER //
// ./assets/js/components/extensions/jquery.notification.js